import { useTranslation } from "react-i18next";
import { Card, CardContent, Grid, Typography } from "@material-ui/core";

export default function FailDetails({ details }) {
  const { t } = useTranslation("tracing");
  const validDetails = details && Boolean(Object.keys(details).length);

  return (
    <Grid item xs={12}>
      <Card variant="outlined" style={{ marginTop: 8 }}>
        <CardContent>
          <Typography color="textSecondary">
            {!validDetails ? (
              t("logNotFound")
            ) : (
              <pre
                style={{
                  margin: 0,
                  whiteSpace: "pre-wrap",
                  wordBreak: "break-word",
                }}
              >
                {JSON.stringify(details, null, 2)}
              </pre>
            )}
          </Typography>
        </CardContent>
      </Card>
    </Grid>
  );
}
